var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InformeCard',{attrs:{"title":"Procedencia","id":"procedencia","name":"procedencia","collapsable":"true"}},[_c('TotalAbonosPorCP',{attrs:{"lista_id":_vm.lista_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }